import React, { useCallback, useMemo } from 'react';
import { Button, Col } from '@cubeyou-team/hx-react-components';
import { connect, useSelector } from 'react-redux';
import { requestCreateConversation } from '../../../../actions';

const ConversationBuilderActions = ({
  runButtonLabel,
  isQueryValid,
  queryBuilder,
  createAudienceModal,
  requestCreateConversation,
}) => {
  const selectedTargetId = useSelector(
    state => state.queryBuilder.target_selected
  );
  const { isLoading } = createAudienceModal;

  const conversationQuery = useMemo(() => {
    const query = {
      ...queryBuilder.targets[selectedTargetId],
    };
    return query;
  }, [queryBuilder, selectedTargetId]);

  const handleButtonClick = useCallback(() => {
    requestCreateConversation(conversationQuery);
  }, [conversationQuery, requestCreateConversation]);

  return (
    <React.Fragment>
      <Col span="auto">
        <Button
          size="small"
          variant="primary"
          disabled={!isQueryValid || isLoading}
          onClick={handleButtonClick}
        >
          {runButtonLabel}
        </Button>
      </Col>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  requestCreateConversation,
};
const mapStateToProps = state => ({
  queryBuilder: state.queryBuilder,
  createAudienceModal: state.createAudienceModal,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationBuilderActions);
